import files from "./files.js"
import view from "./view.js"
import logic from "./logic.js"
import wordsTips from "./wordsTips.js"
import input from "./input.js"

export default {
  files, view, logic, wordsTips, input,
  adsTips: []
}



// WEBPACK FOOTER //
// ./src/config/index.js